import Quill from 'quill';

export const create = (options = {}) => {
  if (!options.container) {
    throw Error('TextEditor.create: container provided is invalid');
  }

  const boxContainer = document.querySelector('.kbx-container');
  const editorContainer = options.container.querySelector('.kbx-text-editor');
  const toolbarContainer = options.container.querySelector('.kbx-text-editor-toolbar');
  let debounce;

  editorContainer.innerHTML = options.content || '';

  const editor = new Quill(editorContainer, {
    modules: {
      toolbar: options.toolbar ? toolbarContainer : false,
    },
    placeholder: options.placeholder || '',
    theme: 'bubble',
  });

  editor.on('selection-change', () => {
    if (!boxContainer) return;

    const boxContainerClientRect = boxContainer.getBoundingClientRect();
    const editorClientRect = editor.container.getBoundingClientRect();
    const tooltip = editor.container.querySelector('.ql-tooltip');
    const tooltipTop = editorClientRect.top - boxContainerClientRect.top;
    const tooltipLeft = editorClientRect.left - boxContainerClientRect.left;

    tooltip.style.marginTop = `${tooltipTop}px`;
    tooltip.style.marginLeft = `${tooltipLeft}px`;
  });

  editor.on('text-change', () => {
    if (debounce) {
      clearTimeout(debounce);
    }

    debounce = setTimeout(() => {
      options.onChange(editor.container.firstChild.innerHTML);
    }, 1000);
  });

  return editor;
};



/** WEBPACK FOOTER **
 ** ./src/helpers/textEditor/index.js
 **/